// 业务工具
import { getQuery, isWPSClient } from './wpsoffice';

export const getBuyPageLink = (extraParams = {}) => {
  const chn = getQuery('chn');
  const locationParse = new URL('https://plus.wps.cn/eduBuy');
  if (chn) {
    locationParse.searchParams.set('chn', chn);
  }
  // 用于创建企业
  locationParse.searchParams.set(
    'utm_source',
    isWPSClient() ? 'WPS365_EDU_PC' : 'WPS365_EDU_WEB',
  );
  for (let paramKey in extraParams) {
    locationParse.searchParams.set(paramKey, extraParams[paramKey]);
  }
  return locationParse.toString();
};

export const openBuyPage = (type = '_blank', extraParams = {}) => {
  window.open(getBuyPageLink(extraParams), type);
};
